import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Home, Users, Building2, Contact, Crosshair, Shield, CheckSquare, Ship, Wallet,
  BookOpen, Gavel, CalendarCheck, Globe2, Package, FileSignature, ClipboardList, BadgeDollarSign, Megaphone, Handshake,
} from 'lucide-react';
import { api } from './api';
import { NAV_AREAS, USER_MENU, visibleAreas } from './nav-areas.mjs';

// One navigation map for the sidebar, the phone menu and the Home page: the five areas in
// nav-areas.mjs (Home, Deals, Shipments, Finance, Knowledge & Website), with icons.
const ICONS = {
  Home, Users, Building2, Contact, Crosshair, Shield, CheckSquare, Ship, Wallet,
  BookOpen, Gavel, CalendarCheck, Globe2, Package, FileSignature, ClipboardList, BadgeDollarSign, Megaphone, Handshake,
};
const withIcon = (i) => ({ ...i, icon: ICONS[i.icon] });
const groupWithIcons = (g) => ({ ...g, items: g.items.map(withIcon) });

export const NAV_GROUPS = NAV_AREAS.map(groupWithIcons);

// Flat list (kept for anything that imported NAV_ITEMS).
export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

// Header user menu (Admin is not in the nav).
export const USER_MENU_ITEMS = USER_MENU.map(withIcon);

// Roles from the JWT. Decode only (no verify): the API enforces auth.
function currentRoles() {
  try {
    const p = JSON.parse(atob(localStorage.getItem('mickey_token').split('.')[1]));
    return Array.isArray(p.roles) ? p.roles : (p.role ? [p.role] : []);
  } catch { return []; }
}

export function isAdminUser() {
  return currentRoles().some((r) => String(r).toLowerCase() === 'admin');
}

export function visibleGroups(roles = currentRoles(), access = {}) {
  return visibleAreas(roles, access).map(groupWithIcons);
}

// Nav items the server must allow (`requires` in nav-areas.mjs). Asked again after a minute,
// on a new sign-in, or after invalidateNavAccess(); any error keeps them hidden.
const ACCESS_TTL_MS = 60 * 1000;
let accessToken = null;
let accessAt = 0;
let accessPromise = null;
export function invalidateNavAccess() { accessPromise = null; }
export function useNavAccess() {
  const [access, setAccess] = useState({});
  const { pathname } = useLocation();
  useEffect(() => {
    let live = true;
    const token = localStorage.getItem('mickey_token');
    if (!accessPromise || accessToken !== token || Date.now() - accessAt > ACCESS_TTL_MS) {
      accessToken = token;
      accessAt = Date.now();
      // A failure hides the item this time but is not cached: the next render asks again.
      accessPromise = api.get('/partner-comp/me').then((m) => ({ partner_comp: m.can_view === true })).catch(() => { accessPromise = null; return {}; });
    }
    accessPromise.then((a) => { if (live) setAccess(a); });
    return () => { live = false; };
  }, [pathname]);
  return access;
}
